export const LIVE_MAP_PATH = '/live-map';
